import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/app/middleware/01.auth.global.ts";
import _02_45load_45user_45global from "/app/middleware/02.load-user.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  _02_45load_45user_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "require-xl-florist": () => import("/app/middleware/require-xl-florist.ts")
}